/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { CURRENCY_URLS } from '@/api/url';
import { isAxiosError } from 'axios';

export const apiGetCurrencies = async (): Promise<ApiResponse<Currency[]>> => {
  try {
    const response = await api.get<ApiResponse<Currency[]>>(CURRENCY_URLS.GET);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
